import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const humanize = (s) => s.replace(/_/g," ").replace(/\b\w/g, c => c.toUpperCase());

export default function TabFront({ project, onChange }) {
  const [fm, setFm] = useState(project.frontmatter);
  const [presets, setPresets] = useState(project.presets);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/ph360/settings/front", { frontmatter: fm, presets });
      onChange(data);
      toast.success("Front matter saved");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };
  const toggleKeys = Object.keys(fm).filter(k => k !== "about_author");
  const presetKeys = [
    "publisher_note","introduction","preface","foreword","acknowledgments","dedication",
    "general_disclaimer","medical_disclaimer","financial_disclaimer","legal_disclaimer",
    "ai_disclosure","about_richard","about_mary","about_research_team",
  ];
  return (
    <>
      <h2>Front Matter</h2>
      {toggleKeys.map(k => (
        <label className="checkbox-line" key={k}>
          <input type="checkbox" checked={!!fm[k]} onChange={(e)=>setFm({...fm,[k]:e.target.checked})} data-testid={`front-toggle-${k}`}/>
          {humanize(k)}
        </label>
      ))}
      <h3>Editable Presets</h3>
      {presetKeys.map(k => (
        <div key={k} style={{marginBottom:8}}>
          <label>{humanize(k)}</label>
          <textarea rows={5} value={presets[k]||""} onChange={(e)=>setPresets({...presets,[k]:e.target.value})} data-testid={`front-preset-${k}`}/>
        </div>
      ))}
      <p style={{marginTop:14}}>
        <button className="button button-primary" onClick={save} disabled={busy} data-testid="front-save">
          {busy ? "Saving…" : "Save Front Matter"}
        </button>
      </p>
    </>
  );
}
